import React, { useContext } from 'react';

import filterTypeCheckers from 'components/FilterPlateForm/filterTypeCheckers';
import useGadgetDrillTarget from 'components/InsightsChat/explainValue/useGadgetDrillTarget';
import { useCompositeChartGadget } from 'components/Studio/CompositeCard/compositeChartPopup';
import DashboardContextMenuContext from 'contexts/DashboardContextMenuContext';
import usePopupCallback from 'hooks/usePopupCallback';
import Typography from 'kingpin/atoms/Typography';

import Option from './Option';

// The term a Driver Performance board popup opens on
const toTerm = (drillDown: FixedFilter | undefined): string | undefined =>
  drillDown && filterTypeCheckers.isTextFilter(drillDown)
    ? drillDown.keywordValues[0]
    : undefined;

const PopupOption = ({
  gadget,
  label,
}: {
  gadget: DashboardGadget;
  label: string;
}) => {
  const { drillDown, closeMenu } = useContext(DashboardContextMenuContext);
  const target = useGadgetDrillTarget(gadget);
  const openPopup = usePopupCallback(
    gadget,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    toTerm(drillDown),
    drillDown,
  );
  if (!openPopup || !target) {
    return null;
  }

  const name = target.name ?? `the ${target.type}`;
  return (
    <Option
      data-testid="composite-chart-popup-option"
      onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.preventDefault();
        e.stopPropagation();
        closeMenu();
        openPopup(drillDown);
      }}
    >
      <Typography.Body type="Label">
        {label !== '' ? `Open ${name} for ${label}` : `Open ${name}`}
      </Typography.Body>
    </Option>
  );
};

// A row opening the clicked chart's popup for the clicked value. Only a
// Composite's chart with a popup has it: a gadget's opens from its header.
const CompositeChartPopupOption = ({ label }: { label: string }) => {
  const gadget = useCompositeChartGadget();
  return gadget ? <PopupOption gadget={gadget} label={label} /> : null;
};

export default CompositeChartPopupOption;
